import { Component } from '@angular/core';
import { SlideComponent } from '../../components/slide/slide.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { CardComponent } from '../../components/card/card.component';
import { HostinglistComponent } from '../hostinglist/hostinglist.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { GuestBookingComponent } from '../guest-booking/guest-booking.component';

@Component({
  selector: 'app-home',
  imports: [
    SlideComponent,
    NavbarComponent,
    CardComponent,
    HostinglistComponent,
    FooterComponent,
    GuestBookingComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

}
